export default __webpack_public_path__ + "static/media/Pic6.3ef500b7.jpg";